<div class="report-container">
  <!-- Page Header -->
  <p class="TXT_TITLE w-30">: : {{ constants.itemDescriptionReportPnA }} : :</p>

  <!-- Filter Form -->
  <div class="report-form">
    <!-- Row 1: Location, Purchasing Office -->
    <div class="form-row">
      <div class="form-field">
        <label class="form-label">{{ constants.location }}:</label>
        <nz-select
          [(ngModel)]="filters.location"
          name="location"
          nzPlaceHolder="Select Location"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let loc of locations"
            [nzValue]="loc.code"
            [nzLabel]="loc.description"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-field">
        <label class="form-label">{{ constants.purchasingOffice }}:</label>
        <nz-select
          [(ngModel)]="filters.purchasingOffice"
          name="purchasingOffice"
          (ngModelChange)="onPurchasingOfficeChange()"
          nzPlaceHolder="Select Purchasing Office"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let po of purchasingOffices"
            [nzValue]="po.purchasingName"
            [nzLabel]="po.purchasingName"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Row 2: Status Checkboxes -->
    <div class="form-row full-width">
      <div class="form-field status-field">
        <div class="status-container">
          <label class="form-label"
            ><span class="required">*</span>{{ constants.status }}:</label
          >
          <div class="status-checkboxes">
            <label
              nz-checkbox
              *ngFor="let status of statusOptions"
              [ngModel]="selectedStatuses.includes(status.key)"
              (ngModelChange)="onStatusChange(status.key, $event)"
              [ngModelOptions]="{ standalone: true }"
            >
              {{ status.label }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 3: Buyer, Request By, Company Code, Item Description (all in one row) -->
    <div class="form-row">
      <div class="form-field">
        <label class="form-label">{{ constants.buyer }}:</label>
        <nz-select
          nzShowSearch
          [(ngModel)]="filters.buyer"
          name="buyer"
          (ngModelChange)="onBuyerDropdownChange()"
          nzPlaceHolder="Select Buyer"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let buyer of filteredBuyers"
            [nzValue]="buyer.userId"
            [nzLabel]="buyer.fullName"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-field">
        <label class="form-label">{{ constants.requestBy }}:</label>
        <nz-select
          nzShowSearch
          [(ngModel)]="filters.owner"
          name="owner"
          (ngModelChange)="onOwnerDropdownChange()"
          nzPlaceHolder="Select Requestor"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let owner of filteredOwners; trackBy: trackByOwner"
            [nzValue]="owner.pnaCreateBy"
            [nzLabel]="owner.pnaRequestor"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-field">
        <label class="form-label">{{ constants.companyCode }}:</label>
        <nz-select
          [(ngModel)]="filters.ccn"
          name="ccn"
          nzPlaceHolder="Select Company Code"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let ccn of ccns"
            [nzValue]="ccn.ccnCode"
            [nzLabel]="ccn.ccnCode"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-field">
        <label class="form-label">{{ constants.itemDescription }}:</label>
        <input
          nz-input
          [(ngModel)]="filters.itemDescription"
          name="itemDescription"
          placeholder="Enter item description..."
        />
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
      <button nz-button nzType="primary" (click)="generateHtmlReport()">
        {{ constants.htmlReportButton }}
      </button>
      <button nz-button nzType="primary" (click)="generateExcelReport()">
        {{ constants.excelReportButton }}
      </button>
    </div>
  </div>

  <!-- Results Table -->
  <div *ngIf="showGrid" class="results-section">
    <p class="TXT_TITLE">{{ constants.itemDetailsReportPnA }}</p>

    <div class="table-container">
      <nz-table
        class="StyleTable"
        #descReport
        [nzData]="reports"
        [nzPageSize]="pageSize"
        [nzPageIndex]="pageIndex"
        nzBordered
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        [nzNoResult]="customNoDataMessage"
      >
        <thead>
          <tr>
            <th></th>
            <th>{{ constants.PnaNo }}</th>
            <th>{{ constants.PnaStatus }}</th>
            <th>{{ constants.manufacturers }}</th>
            <th>{{ constants.itemNo }}</th>
            <th>{{ constants.itemDescription }}</th>
            <th>{{ constants.itemQty }}</th>
            <th>{{ constants.ItemUOM }}</th>
            <th>{{ constants.jDEItem }}</th>
            <th>{{ constants.qACode }}</th>
            <th>{{ constants.suggestedSupplier }}</th>
            <th>{{ constants.itemPriority }}</th>
            <th>{{ constants.itemComment }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let report of descReport.data; let i = index">
            <td>{{ (pageIndex - 1) * pageSize + i + 1 }}</td>
            <td>{{ report.pnaNo }}-{{ report.pnaYear }}</td>
            <td>{{ report.pnaStatus }}</td>
            <td>{{ report.itemManufacturer }}</td>
            <td>{{ report.itemNo }}</td>
            <td>{{ report.itemDesc }}</td>
            <td>{{ report.itemQuantity }}</td>
            <td>{{ report.itemUom }}</td>
            <td>{{ report.itemJdeItemNo }}</td>
            <td>{{ report.itemQa }}</td>
            <td>{{ report.itemSuggestSupplier }}</td>
            <td
              [ngStyle]="{
                'background-color': getPriorityColor(report.itemPriority)
              }"
            >
              {{ report.itemPriority }}
            </td>
            <td>{{ report.itemComment }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
